export default {
  // Hero Section
  'hero.badge': 'Fan Engagement Ecosystem',
  'hero.subtitle': 'The Transparent Fan Engagement Ecosystem',
  'hero.description': 'A global mobile gaming platform that combines free-to-play gameplay, GamePass revenue, and an NFT-based asset economy in a clearly structured ecosystem.',
  'hero.btnModel': 'Understand the Model',
  'hero.btnFlow': 'View Value Flow',
  
  // Video Section
  'video.title': 'The Vision of SuperOne by CEO',
  'video.ceo': 'Andreas Christensen',
  'video.subtitle': 'presented',
  'video.soundNote': 'Click on the video to activate sound',
  
  // What is SuperOne
  'what.title': 'What is',
  'what.description': 'A fast, competitive quiz game about sports, culture and entertainment – based on real digital revenue, not on deposits without value.',
  'what.feature1.title': 'Free-to-Play + GamePass',
  'what.feature1.desc': 'Free entry with premium options for more playtime',
  'what.feature2.title': 'NFT Rental Models',
  'what.feature2.desc': 'Digital assets for rental to active players',
  'what.feature3.title': 'Lootboxes as Assets',
  'what.feature3.desc': 'Digital possessions with real utility',
  'what.feature4.title': 'Token Rewards',
  'what.feature4.desc': 'Rewards based on gameplay activity',
  'what.feature5.title': 'Revenue-based Affiliate',
  'what.feature5.desc': 'Commissions from real purchases, not from participation fees',
  'what.feature6.title': 'Competitive Gaming',
  'what.feature6.desc': 'Fast quiz battles with real prizes',
  
  // App Section
  'app.badge': 'Now Available',
  'app.title': 'SuperOne is',
  'app.titleHighlight': 'live',
  'app.subtitle': 'Download the app now and experience the Battle Royale Quiz Game',
  'app.downloadTitle': 'Download Now',
  'app.gamePrinciple': 'The Game Principle',
  'app.gamePrincipleDesc': 'A fast, competitive football quiz in Battle Royale format',
  'app.prizePool': 'Prize Pool',
  'app.prizePoolDesc': 'Win real cash prizes',
  'app.weekly': 'Weekly',
  'app.daily': 'Daily',
  'app.winners': 'Winners',
  'app.howItWorks': 'How it Works',
  'app.step1.title': 'Free-to-Play',
  'app.step1.desc': '10 free games daily for every player – no risk, start immediately',
  'app.step2.title': 'GamePass',
  'app.step2.desc': 'Want to play more? Buy a GamePass for just $1 and play unlimited',
  'app.step3.title': 'Win',
  'app.step3.desc': 'Compete in Battle Royale and win real cash prizes – daily and weekly',
  'app.valueCreation': 'Clear Value Creation',
  'app.valueCreationDesc': 'SuperOne\'s value creation is based on real GamePass purchases – not on deposits or participation fees',
  'app.freeGames': 'Free Games',
  'app.freeGamesDesc': 'Daily for free',
  'app.gamePassPrice': 'GamePass $1',
  'app.gamePassDesc': 'Play unlimited',
  'app.realRevenue': 'Real Revenue',
  'app.realRevenueDesc': 'Sustainable model',
  
  // Traction Section
  'traction.badge': '7+ Months Live Pilot',
  'traction.title': 'Validated',
  'traction.titleHighlight': 'Traction',
  'traction.description': 'Successful pilot over 7+ months with 32 (50) clubs and 22 languages. Stickiness validated through engagement, retention and virality',
  'traction.source': 'Source: Verified data from SuperOne',
  'traction.cashPrizes': 'Cash prizes',
  'traction.gamesPlayed': 'Games played',
  'traction.hoursPlayed': 'Hours played',
  'traction.uniquePlayers': 'Unique players',
  'traction.clubs': 'Clubs',
  'traction.languages': 'Languages',
  'traction.months': 'Months',
  'traction.referrals': 'Referrals',
  'traction.stickinessTitle': 'Stickiness Validated',
  'traction.stickinessDesc': 'The pilot phase confirmed the three decisive success factors',
  'traction.engagement': 'Engagement',
  'traction.engagementDesc': '35 games daily show high user activity and fun',
  'traction.retention': 'Retention',
  'traction.retentionDesc': '3 hours daily prove strong user retention over months',
  'traction.virality': 'Virality',
  'traction.viralityDesc': '27 monthly referrals demonstrate organic growth',
  'traction.conclusion': 'These metrics form the foundation for SuperOne\'s global scaling',
  
  // Market Opportunity
  'market.badge': 'Global Growth Market',
  'market.title': 'Market',
  'market.titleHighlight': 'Opportunity',
  'market.description': 'The mobile gaming market is growing exponentially – SuperOne positions itself in a billion-dollar market',
  'market.growth': 'Growth in 5 years',
  'market.userGrowth': 'User growth worldwide',
  'market.mobileGamers': 'Mobile Gamers',
  'market.marketShare': 'Market Share',
  'market.marketShareDesc': 'Mobile gaming is the largest segment of the gaming industry',
  'market.quizTrivia': 'Quiz & Trivia',
  'market.quizTriviaDesc': 'Fast-growing segment with high engagement',
  'market.dailyTime': 'Daily',
  'market.dailyTimeDesc': 'Average playtime per mobile gamer',
  'market.avgArpu': 'Avg. ARPU',
  'market.avgArpuDesc': 'Average revenue per mobile gaming user',
  'market.positioning': 'SuperOne Positioning',
  'market.positioningDesc': 'SuperOne combines the strengths of the Quiz & Trivia segment with innovative Web3 elements and positions itself in a $148.6B market by 2029',
  
  // Monetization
  'monetization.badge': 'Monetization Validated',
  'monetization.title': 'Proven',
  'monetization.titleHighlight': 'Monetization',
  'monetization.description': 'SuperOne is based on proven monetization models of the most successful mobile games worldwide',
  'monetization.validated': 'Monetization validated in pilot game',
  'monetization.baseArpu': 'Base ARPU Game only',
  'monetization.fullArpu': 'Full ARPU Ads + data',
  'monetization.conversion': 'Conversion to paid',
  'monetization.annualArpu': 'Annual ARPU',
  'monetization.adViews': 'Annual ad views',
  'monetization.adRevenue': 'Annual ad revenue',
  'monetization.benchmark': 'SuperOne Benchmark',
  'monetization.benchmarkDesc': 'With $100-200 Annual ARPU, SuperOne positions itself in the mid-range of successful mobile games and uses proven monetization strategies from the gaming industry.',
  
  // Roadmap
  'roadmap.badge': 'Growth Strategy',
  'roadmap.title': 'The Roadmap to a Possible Token Price of',
  'roadmap.subtitle': 'Fan Growth + Token Value – Growth to 10M in 6 months, 100M by 2026 and 1B by 2030',
  'roadmap.disclaimer': '(no guarantee)',
  'roadmap.activeFans': 'Active Fans',
  'roadmap.monetizedFans': 'Monetized Fans',
  'roadmap.grossRevenue': 'Gross Revenue',
  'roadmap.inStaking': 'In Staking',
  'roadmap.marketCap': 'Market Cap',
  'roadmap.virality': 'Virality of 2 - Probability 50%',
  'roadmap.arpuGrowth': 'ARPU Growth Path',
  'roadmap.cryptoMarket': 'The crypto market is estimated to grow 200% to beyond $10T by 2030',
  
  // Technology
  'tech.badge': 'Enterprise-Grade Stack',
  'tech.title': 'Proven',
  'tech.titleHighlight': 'Technology',
  'tech.description': 'SuperOne is based on state-of-the-art, scalable technologies – proven by leading tech companies',
  'tech.trust': 'Trust through proven technology',
  'tech.performance': 'High Performance',
  'tech.performanceDesc': 'Fast & smooth',
  'tech.scalable': 'Scalable',
  'tech.scalableDesc': 'Millions of users',
  'tech.secure': 'Secure',
  'tech.secureDesc': 'Enterprise-Grade',
  
  // Two Perspectives
  'perspectives.title': 'Two Perspectives,',
  'perspectives.titleHighlight': 'One Ecosystem',
  'perspectives.forPlayers': 'For Players',
  'perspectives.forOwners': 'For Lootbox Owners',
  'perspectives.gamepass.title': 'GamePass (Main Revenue)',
  'perspectives.gamepass.point1': '10 free games daily for every user',
  'perspectives.gamepass.point2': 'Want to play more? Buy a Daily, Weekly or Monthly GamePass',
  'perspectives.gamepass.point3': 'Primary monetization – fully App Store compliant',
  'perspectives.nftRent.title': 'NFT Rental',
  'perspectives.nftRent.point1': 'Players don\'t buy lootboxes',
  'perspectives.nftRent.point2': 'Instead, they rent NFT items from lootbox owners',
  'perspectives.nftRent.point3': 'In-app fees generate real revenue',
  'perspectives.tokenRewards.title': 'Token Rewards',
  'perspectives.tokenRewards.desc': 'Regular token distributions based on gameplay activity and lootbox category',
  'perspectives.nftIncome.title': 'NFT Rental Income',
  'perspectives.nftIncome.desc': 'Share of rental income for each NFT rental – a pure usage revenue share',
  'perspectives.affiliate.title': 'Affiliate Commissions',
  'perspectives.affiliate.desc': 'Commissions from real revenue like GamePass purchases – no participation fees',
  
  // Value Flow
  'flow.title': 'The',
  'flow.titleHighlight': 'Value Flow',
  'flow.description': 'Short & transparent – this is how value flows in the SuperOne ecosystem',
  'flow.step1.title': 'Revenue is Generated',
  'flow.step1.desc': 'Players buy GamePass or rent NFT items → Real in-app revenue is generated',
  'flow.step2.title': 'Revenue Distribution',
  'flow.step2.desc': 'The generated revenue is transparently distributed:',
  'flow.step2.note': 'Everything is based on digital consumption – not on financial contributions from users',
  
  // Why Sustainable
  'sustainable.title': 'Why This Model is',
  'sustainable.titleHighlight': 'Sustainable',
  'sustainable.subtitle': '',
  'sustainable.reason1.title': 'Free-to-Play Entry',
  'sustainable.reason1.desc': 'No barriers – everyone can start for free',
  'sustainable.reason2.title': 'GamePass Monetization',
  'sustainable.reason2.desc': 'Proven model from the gaming industry',
  'sustainable.reason3.title': 'NFT Assets for Rental',
  'sustainable.reason3.desc': 'Digital possessions with real utility',
  'sustainable.reason4.title': 'Activity-based Rewards',
  'sustainable.reason4.desc': 'Token rewards through real gameplay activity',
  'sustainable.reason5.title': 'Revenue-based Affiliate',
  'sustainable.reason5.desc': 'Commissions only from real purchases',
  'sustainable.reason6.title': 'No Financial Model',
  'sustainable.reason6.desc': 'Entertainment ecosystem with product value',
  'sustainable.conclusion': 'SuperOne is not a financial or investment model, but an entertainment ecosystem with real product value and real revenue.',
  
  // Telegram CTA
  'telegram.title': 'Still Have Questions About SuperOne?',
  'telegram.description': 'Our Telegram bot answers all your questions and helps you understand SuperOne even better!',
  'telegram.button': 'To Telegram Bot',
  
  // Conclusion
  'conclusion.title': 'Conclusion',
  'conclusion.description': 'SuperOne combines gaming, digital assets and reward mechanics in a clear, transparent and sustainable model.',
  'conclusion.value': 'All economic value is created through usage, gameplay activity and digital purchases – not through new participants.',
  'conclusion.button': 'Learn More Now',
  
  // Disclaimer
  'disclaimer': 'Note: DigitalSports is an independent affiliate partner of SuperOne. This is not the official company website. All data and facts are verified and come from SuperOne.',
};